import { useEffect } from "react";

const AttractionDescription = ({ name, description,
    expanded,
    setExpanded,
    descriptionRef,
    isOverflowing,
}) => {

    useEffect(() => {
        const container = descriptionRef.current;
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = description;
        const scriptTags = tempDiv.querySelectorAll('script');
        scriptTags.forEach((oldScript) => {
            const newScript = document.createElement('script');
            for (let attr of oldScript.attributes) {
                newScript.setAttribute(attr.name, attr.value);
            }
            newScript.text = oldScript.textContent;

            container.appendChild(newScript);
        });
    }, [description]);

    return (
        <section className="welcome">
            <div className="container">
                <div className="container mb-5"
                // style={{ fontFamily: 'Manrope-Regular' }}

                >
                    {
                        name != '' && description != null &&
                        <div className="sectionTitle">
                            <h3>More to know about {name}</h3>
                        </div>
                    }
                    {/* <div
                  
                        id='full_description_text_activity'
                        className={`full_description_text_activity ${expanded ? "expanded" : "collapsed"}`}
                        dangerouslySetInnerHTML={{ __html: description ? (description) : '' }}
                        ref={descriptionRef}
                    /> */}
                    {/* <div
                      id='full_description_text_activity'
                      className={`full_description_text_activity ${expanded ? "expanded" : "collapsed"}`}
                        ref={descriptionRef}
                        dangerouslySetInnerHTML={{
                            __html: description.replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, ''),
                        }}
                    /> */}
                    {
                    description != null ?
                    
                    <div
                        id='full_description_text_activity'
                        className={`comon-tags-class full_description_text_activity ${expanded ? "expanded" : "collapsed"}`}
                        ref={descriptionRef}
                        dangerouslySetInnerHTML={{
                            __html: description ? description?.replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '') : "",
                        }}
                    /> : ''}
                    {
                        isOverflowing &&
                        <div className="showmoreBtn" style={{ marginTop: "5px", textAlign: "center" }}>
                            <a href="javascript:void(0)" className="atag_btn" onClick={() => setExpanded(!expanded)}>
                                {expanded ? "Show less" : "Show more"}
                            </a>
                        </div>
                    }
                    {/* <iframe
                        srcDoc={description}
                        style={{ fontFamily: 'Manrope-Regular', width: '100%', height: '100%', border: 'none', fontFamily: 'Arial, sans-serif' }}
                    /> */}
                </div>
            </div>
        </section>
    )

}
export default AttractionDescription